import { render } from "./TermsComponent.vue?vue&type=template&id=4741113b"
import script from "./TermsComponent.vue?vue&type=script&lang=js"
export * from "./TermsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__